import JodiReportUsersTable from "../../admin/JodiReportUsers/Index";

const OperatorJodiReportUsers = () => (
  <JodiReportUsersTable basePath="/operator" />
);

export default OperatorJodiReportUsers;
